import { AvailableServices } from './available-services/available-services';
import { DraftReferralRequests } from './draft-referral-requests/draft-referral-requests';
import { SubmittedReferrals } from './submitted-referrals/submitted-referrals';

const Home = () => (
  <>
    <AvailableServices />
    <DraftReferralRequests />
    <SubmittedReferrals />
  </>
);

export { Home };
